


























































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { parse, compareAsc } from 'date-fns'

// Mixins
import Form from '@/mixins/Form'
import Phone from '@/mixins/Phone'

// Components
import DatePicker from '@/components/common/DatePicker.vue'

@Component({
  components: { DatePicker }
})
export default class AssignReportForm extends Mixins(Form, Phone) {
  title: string = null
  description: string = null
  email: string = null
  sms: boolean = false
  sameReceiver: boolean = false
  startDate: string = null
  dueDate: string = null
  phoneNumber: string = null
  validatePhoneNumber: string = null

  @Prop({ type: Boolean, default: false }) dropoff: boolean
  @Prop({ type: Object, default: null }) data

  @Getter('canSendSMS', { namespace: 'user' }) canSendSMS

  @Watch('startDate')
  checkDueDate(startDate) {
    if (this.dueDate && compareAsc(startDate, this.dueDate) === 1) {
      this.dueDate = null
    }
  }

  get today() {
    const d = new Date()
    d.setDate(d.getDate() - 1)
    return d
  }

  get minEndDate() {
    return parse(this.startDate) || this.today
  }

  get assignFormValid() {
    if (this.sms) {
      return this.formValid && !!this.startDate && this.validatePhoneNumber
    } else {
      return this.formValid && !!this.startDate
    }
  }

  submitForm() {
    if (!this.assignFormValid) {
      return
    }

    const data = {
      title: this.title,
      description: this.description,
      email: this.email,
      startDate: this.startDate,
      dueDate: this.dueDate,
      sendSms: this.sms,
      phoneNumber: this.validatePhoneNumber,
    }

    this.$emit('submit', {...data, resend: this.sameReceiver })
  }

  created() {
    if (!this.data) {
      this.startDate = new Date().toISOString()
      return
    }

    this.title = this.data.title || null
    this.description = this.data.description || null
    this.email = this.data.edit ? this.data.email : null
    this.startDate = this.data.startDate || new Date().toISOString() || null
    this.dueDate = this.data.dueDate || null
  }
}
